<template>
<div class="bottomNavigationBar">
    <ul>
        <li :class="{ active: isActive('/') }">
            <a href="/">
                <div class="icon">
                    <HomeIcon />
                </div>
                <div class="label">
                    ホーム
                </div>
            </a>
        </li>
        <li :class="{ active: isActive('/coupons') }">
            <a href="/coupons">
                <div class="icon">
                    <CouponIcon/>
                </div>
                <div class="label">
                    クーポン
                </div>
            </a>
        </li>
        <li :class="{ active: isActive(favoriteUrl) }">
            <a :href="favoriteUrl">
                <div class="icon">
                    <FavoriteIcon />
                </div>
                <div class="label">
                    お気に入り
                </div>
            </a>
        </li>
        <li :class="{ active: isArticleOrMovieActive() }">
            <a href="/article">
                <div class="icon">
                    <ArticleIcon />
                </div>
                <div class="label">
                    ニュース/動画
                </div>
            </a>
        </li>
        <li :class="{ active: isActive('/mypage') }">
            <a href="/mypage">
                <div class="icon">
                    <MypageIcon />
                </div>
                <div class="label">
                    マイページ
                </div>
            </a>
        </li>
    </ul>
</div>
</template>

<script>
import HomeIcon from './HomeIcon.vue'
import CouponIcon from './CouponIcon.vue'
import FavoriteIcon from './FavoriteIcon.vue'
import ArticleIcon from './ArticleIcon.vue'
import MypageIcon from './MypageIcon.vue'

export default {
  props: {
    auth: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'HomeIcon': HomeIcon,
    'CouponIcon': CouponIcon,
    'FavoriteIcon': FavoriteIcon,
    'ArticleIcon': ArticleIcon,
    'MypageIcon': MypageIcon
  },
  data() {
    return {
      favoriteUrl: '/mypage/favorite'
    }
  },
  mounted() {
    this.favoriteUrl = this.auth ? '/mypage/favorite' : '/favorite';
  },
  methods: {
    isActive(path) {
      return path === location.pathname;
    },
    isArticleOrMovieActive() {
      return location.href.includes('article') || location.href.includes('movie');
    }
  }
}
</script>

<style lang="scss">
@import '../../../../resources/sass/media_query.scss';

.bottomNavigationBar {
    @include pc {
        display: none;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 6.4rem;
    background: #fff;
    border-top: 1px solid #EDEDED;
    font-size: 1rem;
    font-weight: bold;
    z-index: 50;
    ul {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        &> li {
            height: 100%;
            color: #6F6F6F;
            svg, path {
                fill: #6F6F6F;
            }
            &>a {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 100%;
                .icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 1.9rem;
                    height: 1.8rem;
                }
                .label {
                    margin-top: .7rem;
                }
            }
            &.active {
                color: #0095C6;
                svg, path {
                    fill: #0095C6;
                }
            }
        }
    }
}
</style>
